import * as Yup from 'yup'

import { phoneNumberSchema } from 'i18n-web/validators'

const validationSchema = countryCode =>
  Yup.object().shape({
    phoneNumber: phoneNumberSchema({ countryCode, requiredMessage: false }),
  })

export default validationSchema
